import { cn } from "@corpuscomplete/web-ui/lib/utils";
import { useDraggable } from "@dnd-kit/core";
import type { CSSProperties, ReactNode } from "react";

export function VerticalDragReorderOverlay<TItem>({
  item,
  width,
  className,
  children,
}: {
  item: TItem | null;
  width?: number;
  className?: string;
  children: (item: TItem) => ReactNode;
}) {
  if (!item) {
    return null;
  }

  return (
    <div
      className={cn("rounded-lg bg-background/95 shadow-lg ring-1 ring-border/80", className)}
      style={width ? { width } : undefined}
    >
      {children(item)}
    </div>
  );
}

export function VerticalDragReorderShellRow({
  id,
  className,
  wrapperStyle,
  itemStyle,
  registerRowElement,
  children,
}: {
  id: string;
  className?: string;
  wrapperStyle?: CSSProperties;
  itemStyle?: CSSProperties;
  registerRowElement?: (element: HTMLDivElement | null) => void;
  children: ReactNode;
}) {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id,
    data: { id, type: "vertical-drag-reorder-row" },
  });

  return (
    <div ref={registerRowElement} style={wrapperStyle}>
      <div
        ref={setNodeRef}
        style={itemStyle}
        className={cn("touch-none select-none", className)}
        {...attributes}
        {...listeners}
      >
        {children}
      </div>
    </div>
  );
}
